import { render, staticRenderFns } from "./waterfallLayout.vue?vue&type=template&id=760da06e&scoped=true&"
import script from "./waterfallLayout.vue?vue&type=script&lang=ts&"
export * from "./waterfallLayout.vue?vue&type=script&lang=ts&"
import style0 from "./waterfallLayout.vue?vue&type=style&index=0&id=760da06e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "760da06e",
  null
  
)

export default component.exports